import React from 'react';

const MetricCard = ({ 
  title, 
  value, 
  icon, 
  color = 'blue',
  description,
  trend,
  onClick 
}) => {
  const colorClasses = {
    blue: {
      bg: 'bg-blue-50',
      text: 'text-blue-700',
      icon: 'text-blue-500',
      value: 'text-blue-600'
    },
    green: {
      bg: 'bg-green-50', 
      text: 'text-green-700',
      icon: 'text-green-500',
      value: 'text-green-600'
    },
    red: {
      bg: 'bg-red-50',
      text: 'text-red-700', 
      icon: 'text-red-500',
      value: 'text-red-600'
    },
    yellow: {
      bg: 'bg-yellow-50',
      text: 'text-yellow-700',
      icon: 'text-yellow-500', 
      value: 'text-yellow-600'
    },
    purple: {
      bg: 'bg-purple-50',
      text: 'text-purple-700',
      icon: 'text-purple-500',
      value: 'text-purple-600'
    }
  };

  const classes = colorClasses[color] || colorClasses.blue;

  return (
    <div 
      className={`${classes.bg} rounded-xl p-6 border border-gray-100 hover:shadow-lg transition-all duration-200 ${onClick ? 'cursor-pointer hover:scale-105' : ''}`}
      onClick={onClick}
    >
      <div className="flex items-center justify-between mb-4">
        <div className={`p-2 rounded-lg ${classes.bg} border border-white/50`}>
          <span className={`text-xl ${classes.icon}`}>{icon}</span>
        </div>
        {trend && (
          <span className={`text-sm font-medium ${trend > 0 ? 'text-green-600' : trend < 0 ? 'text-red-600' : 'text-gray-600'}`}>
            {trend > 0 ? '↗' : trend < 0 ? '↙' : '→'} {Math.abs(trend)}%
          </span>
        )}
      </div>
      
      <div>
        <p className={`text-sm font-medium ${classes.text} mb-1`}>
          {title}
        </p>
        <p className={`text-3xl font-bold ${classes.value} mb-2`}>
          {value}
        </p>
        {description && (
          <p className="text-sm text-gray-600">
            {description}
          </p>
        )}
      </div>
    </div>
  );
};

export default MetricCard;